import * as moment from 'moment-timezone';
export const isTimezoneValid = (timezone) => moment.tz.names().includes(timezone);
